module.exports = __webpack_public_path__ + "img/21-2.91ccf619.png";